import React, { useEffect } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Modal,
  TextAction,
  ParagraphText,
  Icon,
} from '@leagueplatform/genesis-core';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { FORMS_LIBRARY_ASSET_KEYS } from '../../../types/forms-library.types';

export function RemoveAttachmentSuccessModal(props: any) {
  const { onClose, openSuccessModal } = props;

  const checkIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.CHECK_ICON);
  const closeIcon = useStaticAsset(FORMS_LIBRARY_ASSET_KEYS.CLOSE_ICON);

  useEffect(() => {
    const modalBtn = document.getElementById('successModalTrigger');
    modalBtn?.click();
  }, [openSuccessModal]);

  return (
    <Modal.Root>
      <Modal.Trigger>
        <Box
          css={
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'flex-end',
              position: 'relative',
              left: '90px',
              marginBottom: '$two',
              contentVisibility: 'hidden',
            } as GDSStyleObject
          }
        >
          <TextAction
            id="successModalTrigger"
            as="button"
            size={{
              '@initial': 'large',
              '@mobile': 'medium',
              '@tablet': 'large',
            }}
          >
            <Icon icon={closeIcon as string} size="17px" />
          </TextAction>
        </Box>
      </Modal.Trigger>
      <Modal.Content
        showCloseButton={false}
        padding="$none"
        width={{ '@initial': 650, '@mobile': '100%' }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <StackLayout
          css={{ textAlign: 'center', padding: '$three $three' }}
          horizontalAlignment="stretch"
        >
          <Box
            css={
              {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              } as GDSStyleObject
            }
          >
            {' '}
            <img
              src={checkIcon as string}
              alt="cross icon"
              width="40px"
              style={{ cursor: 'pointer' }}
            />
          </Box>
          <Modal.Title>
            <HeadingText
              level="display"
              size="sm"
              css={{ padding: '$oneAndHalf $none' } as GDSStyleObject}
            >
              Success
            </HeadingText>
          </Modal.Title>
          <ParagraphText data-testid="successId" emphasis="subtle">
            You have successfully deleted the attachment.
          </ParagraphText>
          <Modal.Close>
            <TextAction
              css={{
                flexDirection: 'column',
                width: '100%',
              }}
              as="button"
              onClick={onClose}
            >
              Close
            </TextAction>
          </Modal.Close>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
}
